module.exports = __webpack_public_path__ + "aedc4fb0.woff2";